import { render, staticRenderFns } from "./ModalObsInterna.vue?vue&type=template&id=42f6d3e9"
import script from "./ModalObsInterna.vue?vue&type=script&lang=js"
export * from "./ModalObsInterna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports